<button mat-icon-button data-cy="columns-menu" [matMenuTriggerFor]="columnsMenu">
  <mat-icon>view_column</mat-icon>
</button>

<mat-menu #columnsMenu="matMenu" class="columns-menu">
  @for (column of allColumns(); track column) {
    <div class="item" mat-menu-item (click)="$event.stopPropagation()">
      <mat-checkbox
        [attr.data-cy]="'item-' + column"
        [ngModel]="displayedColumns().includes(column)"
        (ngModelChange)="selectColumn(column)"
      >
        {{ translateKey()(column) | translate }}
      </mat-checkbox>
    </div>
  }
</mat-menu>
